import { Property } from "@stratify/shared";
import { EventChannel, eventChannel } from "redux-saga";
import {
  call,
  CallEffect,
  put,
  PutEffect,
  take,
  TakeEffect,
} from "redux-saga/effects";
import { auth } from "../../../config/firebase";
import { subscribeToProperties } from "../api/propertiesApi";
import {
  fetchPropertiesError,
  fetchPropertiesSuccess,
} from "./propertiesSlice";

interface FirestoreChannelPayload {
  properties?: Property[];
  error?: Error;
}

function createFirestoreChannel(
  userId: string
): EventChannel<FirestoreChannelPayload> {
  return eventChannel((emit) => {
    const unsubscribe = subscribeToProperties(
      userId,
      (properties) => emit({ properties }),
      (error) => emit({ error })
    );

    // Return unsubscribe function
    return unsubscribe;
  });
}

export function* handleSubscriptionTask(): Generator<
  CallEffect | PutEffect | TakeEffect,
  void,
  any
> {
  if (!auth.currentUser) {
    yield put(fetchPropertiesError("User not authenticated"));
    return;
  }

  const channel = yield call(createFirestoreChannel, auth.currentUser.uid);

  try {
    while (true) {
      const { properties, error } = yield take(channel);

      if (error) {
        yield put(fetchPropertiesError(error.message));
        return;
      }

      yield put(fetchPropertiesSuccess(properties));
    }
  } finally {
    channel.close();
  }
}
